import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "~/lib/client";
import { handleApiError, handleResponse } from "~/utils/response";
import { consultationKeys } from "./keys";

interface Consultation {
    type: 'consultation';
    user_id: string;
    encounter_datetime: string;
    cost: number;
    payment_status: 'paid' | 'unpaid';
    recommended_tasks: any[];
    created_at: number;
    encounter_id: string;
    notes: string | null;
}

interface ConsultationResponse {
    status: 'success';
    message: string | null;
    consultation: Consultation;
}

export const getConsultationQueryOptions = (id?: string) => {
    return queryOptions({
        queryKey: consultationKeys.consultationById(id),
        retry: false,
        queryFn: async () => {
            try {
                const response = await apiClient(`/consultations/${id}`);

                const result = await handleResponse<ConsultationResponse>(response);
                if (!result.success) {
                    throw new Error(result.error);
                }
                return result.data.consultation;
            } catch (error) {
                handleApiError(error);
            }
        },
        enabled: !!id
    });
};